import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { dismiss } from '@ionic/core/dist/types/utils/overlays';
import { Organization, User } from 'src/app/models';
import { OrganizationService, UserService } from 'src/app/services';

@Component({
  selector: 'app-upgrade-modal',
  templateUrl: './upgrade-modal.component.html',
  styleUrls: ['./upgrade-modal.component.scss'],
})
export class UpgradeModalComponent implements OnInit {

  public activeOrganization: Organization;
  public activeUser: User;
  public mode: "user" | "organization";

  @Input() message: string;
  @Input() targetPlan: string;

  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private organizationService: OrganizationService,
    private userService: UserService,
  ) { }

  ngOnInit() {
    this.activeUser = this.userService.getAppUser();
    this.activeOrganization = this.organizationService.getAppOrganization();

    this.mode = this.activeOrganization && this.activeOrganization.isUserTrainer(this.activeUser.uid)? "organization" : "user";
  }

  getActivePlan() {
    if(this.mode === "organization") {
      return this.activeOrganization.plan
    } else {
      return  "free"
    }
  }

  upgrade() {
    if(this.mode === "user") {
      this.navCtrl.navigateForward('/upgrade-plan?personal=true');
    } else {
      this.navCtrl.navigateForward('/upgrade-plan');
    }
    this.modalCtrl.dismiss(null, "upgrading");
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
